import { render, staticRenderFns } from "./game-providers.vue?vue&type=template&id=f9b7dd16"
import script from "./game-providers.vue?vue&type=script&lang=js"
export * from "./game-providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/game-providers.vue
// module id = DmRN
// module chunks = 0